import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7db4920"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-dashboard-root-posts" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Objave ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "message" }
const _hoisted_9 = {
  key: 0,
  class: "preview"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "date-and-action" }
const _hoisted_12 = { class: "date" }
const _hoisted_13 = { class: "action" }
const _hoisted_14 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorDashboardRootPostsFormCreateIndexVue = _resolveComponent("AppAdministratorDashboardRootPostsFormCreateIndexVue")!
  const _component_AppAdministratorDashboardRootPostsFormUpdateIndexVue = _resolveComponent("AppAdministratorDashboardRootPostsFormUpdateIndexVue")!
  const _component_AppAdministratorDashboardRootPostsFormRemoveIndexVue = _resolveComponent("AppAdministratorDashboardRootPostsFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorDashboardRootPostsFormCreateIndexVue, { onGetPosts: _ctx.getPosts }, null, 8, ["onGetPosts"])
      ]),
      (_ctx.posts.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: post.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(post.user.content.name) + " " + _toDisplayString(post.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(post.content.message), 1),
                  (post.content.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("iframe", {
                          width: "100%",
                          src: _ctx.getVideoURL(post.content.url)
                        }, null, 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("strong", null, "Datum: " + _toDisplayString(_ctx.moment(post.created_at).format('DD.MM.YYYY.')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_AppAdministratorDashboardRootPostsFormUpdateIndexVue, {
                        post: post,
                        onGetPosts: _ctx.getPosts
                      }, null, 8, ["post", "onGetPosts"]),
                      _createVNode(_component_AppAdministratorDashboardRootPostsFormRemoveIndexVue, {
                        post: post,
                        onGetPosts: _ctx.getPosts
                      }, null, 8, ["post", "onGetPosts"])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, " Nema podataka... "))
    ])
  ]))
}